import { isRecord } from "@/lib/utils"

/**
 * Pure helpers for reading vendor records by path, shared by the explorer grid and the
 * pull workbook. A to-many value is a plain array (Loxo, JobAdder) or Bullhorn's
 * `{ total, data }` envelope.
 */

/**
 * Reads a path out of a record. "[]" maps over a list and returns the values of its
 * items; a missing segment reads as undefined.
 */
export function valueAtPath(record: unknown, path: string): unknown {
  return path.split(".").reduce<unknown>((current, segment) => readSegment(current, segment), record)
}

function readSegment(current: unknown, segment: string): unknown {
  if (current === null || current === undefined) return undefined
  if (Array.isArray(current)) return current.map((item) => readSegment(item, segment))
  const isList = segment.endsWith("[]")
  const key = isList ? segment.slice(0, -2) : segment
  const value = key === "" ? current : isRecord(current) ? current[key] : undefined
  return isList ? listItems(value) : value
}

/** The items of a to-many value, none for anything that is not a list */
export function listItems(value: unknown): unknown[] {
  if (Array.isArray(value)) return value
  if (isRecord(value) && Array.isArray(value.data)) return value.data
  return []
}
